// src/context/NotificationContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'userNotifications';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState({
    likes: [],
    messages: [],
    views: [],
  });

  // Load from localStorage on init
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        setNotifications(JSON.parse(stored));
      } catch {
        console.warn('Invalid notifications in storage');
      }
    }
  }, []);

  // Save to localStorage when notifications change
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(notifications));
  }, [notifications]);

  const addNotification = (type, data) => {
    setNotifications((prev) => ({
      ...prev,
      [type]: [...prev[type], data],
    }));
  };

  const clearNotifications = (type) => {
    setNotifications((prev) => ({
      ...prev,
      [type]: [],
    }));
  };

  const getUnreadCount = (type) => {
    return notifications[type]?.length || 0;
  };
  
  const getNotifications = (type) => {
    return notifications[type] || [];
  };

  return (
    <NotificationContext.Provider
      value={{ notifications, addNotification, clearNotifications, getUnreadCount, getNotifications }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
